import $axios from "../../api/axios";

function getLstApi({ params, callback }) {
  $axios
    .get(`/api/houseConstructionList/${params}`)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function getDtlApi({ params, callback }) {
  $axios
    .get(`/api/houseConstruction/${params}`)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

export default {
  getLstApi,
  getDtlApi
};



// WEBPACK FOOTER //
// ./src/api/account/construction.js